export const CACHE_KEY = 'artistremuneration-page';
